var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'kw_icon i-class i-icon '+( _vm.type === '' ? '' : 'i-icon-' +  _vm.type )+' '+( _vm.custom ),style:('font-size: '+( _vm.size )+'px; '+( _vm.color ? 'color:' + _vm.color : '' )),on:{"click":_vm.kwIconClick}})}
var staticRenderFns = []

export { render, staticRenderFns }